module.exports = "/build/web/svg/sponsor/zonneplan-wit.89eb6dfe71045dec542fb4046d0e89f4.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/zonneplan-wit.svg
// module id = 229
// module chunks = 24